<template>
    <div>
      <div class="row justify-content-between align-items-center">
        <div class="col-md-4 customHeading">
          <h3>{{moduleName}}</h3>
        </div>

      
      </div>
      <div class="row">
        <div class="col">
        <hr color="#CACACA" style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;">
        </div>
      </div>
      <div>
        <div class="row">
          <div class="col">
            <form ref="BillingFrom" style="margin-top:4%">
              <div class="row">
              
                  <!--NAME INPUT-->
                  <div class="col-md-3"></div>
                  <div class="col-md-6 shadow-custom">
                    <b-form-group  label="From" label-for="datepicker-1" autocomplete="off">
                        <b-form-datepicker id="datepicker-1" v-model= "FromDate" placeholder="Choose a date" local="en" required></b-form-datepicker>
                    </b-form-group>
                    <b-form-group  label="To" label-for="datepicker-2" autocomplete="off">
                        <b-form-datepicker id="datepicker-2" v-model= "ToDate" placeholder="Choose a date" local="en" required></b-form-datepicker>
                    </b-form-group>
                    <b-form-group label="Client" label-for="Client" autocomplete="off">
                        <b-form-select v-model= "SelectedDepoId" :options="clients" value-field="id" text-field="name">
                            <b-form-select-option :value = null disabled hidden>Select Depo</b-form-select-option>
                        </b-form-select>
                    </b-form-group>
                   
                     <button type="button" style="width:130px;background-color:#5bb8cd;color:white" class="btn" @click ="generateBill()">Generate Bill</button>
                  </div>
                  <div class="col-md-3"></div>
              </div>
                  
            </form>
          </div>
      </div>

      

    
    <Spinner v-if="isLoading" message="Loading..." size="medium" 
      line-fg-color="rgb(222 224 219" 
      line-bg-color="rgb(68 66 62)">
    </Spinner>
    <!--/SPINNER-->	
      </div>
        <Toaster ref ="toaster"/>
   </div>
</template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Spinner from 'vue-simple-spinner'
import Toaster from '../toaster';
export default {
    name: 'ShipmentBilling',
    data(){
        return{
          moduleName:'Shipment Billing',
          Id:null,
          isLoading:false,
          SelectedDepoId:null,
          FromDate:null,
          ToDate:null,
          clients:null,
		}
  },
 created()
 {
   this.getDepos();
 },
methods:
{
  getDepos()
    {
      this.isLoading = true;
      axios.post('/depo/getall',{"UserId":this.$auth.user().id,"CompanyId":this.$auth.user().companyId,
      "PageSize":this.perPage,"Page":this.page})
      .then(res=>
      {
        this.isLoading = false;
        if(res.data.status ==1)
        {
          // console.log(res.data)
          // this.wheatIssues=res.data.data.records;
          this.clients = res.data.data;
        }
        else if (res.data.status == 0)
        {
          this.clients = null
        }
        else if(res.data.status == -1)
        {
            this.$refs.toaster.showToast('Error','danger',res.data.msg)
        }
      });
    },
   generateBill(){ 
     if(this.SelectedDepoId == null)
     {
       this.$refs.toaster.showToast('Error','danger','Please select a depo')
       return;
     }
     if(this.FromDate == null || this.ToDate == null)
     {
       this.$refs.toaster.showToast('Error','danger','Please choose a valid date')
       return;
     }
     let model =  {
        "FromDate":this.FromDate,
        "ToDate":this.ToDate,
        "DepoId":this.SelectedDepoId,
        "CompanyId":this.$auth.user().companyId,
        "UserId":this.$auth.user().id
      };

     axios({
    url: '/shipment/generatebill',
    method: 'POST',
    responseType: 'arraybuffer',
    data:model
    }).then((response) => {
        console.log(response)
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement('a');
    
        fileLink.href = fileURL;
        fileLink.setAttribute('download', 'bill.xlsx');
        document.body.appendChild(fileLink);
            
        fileLink.click();
       
    });

   },
   
  
      resetModal() {
     
        this.FromDate = null;
        this.ToDate = null;
        this.SelectedDepoId = null; 
       
      },   
  },
  
  components:{
    Spinner,
    Toaster
  },
  
}
</script>

<style scoped>
button.page-link {
	display: inline-block;
}
button.page-link {
    font-size: 20px;
    color: #29b3ed;
    font-weight: 500;
}
.offset{
  width: 500px !important;
  margin: 20px auto;  
}
select#class-dropdown{
    width: 80%;
    margin-left: 16%
}
.row{
  margin-left:0px;
  margin-right:0px;
}
.col{
  padding-left:0px;
  padding-right:0px;
}
</style>